import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Link2 } from 'lucide-react';
import { QB_ADMIN_PASSWORD } from './qbAwards';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function QBPickemLinker({ currentWeek }) {
  const [games, setGames] = useState([]);
  const [week, setWeek] = useState(currentWeek || 1);
  const [linking, setLinking] = useState(null);

  const load = () => axios.get(`${API}/qb/pickem-games-for-linking`).then(r => setGames(r.data.games)).catch(() => toast.error('Failed to load games'));
  useEffect(() => { load(); }, []);

  const link = async (gameId) => {
    setLinking(gameId);
    try {
      const res = await axios.post(`${API}/qb/link-pickem-result`, { game_id: gameId, week, password: QB_ADMIN_PASSWORD });
      if (res.data.success) {
        toast.success(`Linked to Week ${week}: ${res.data.updated_qbs.map(q => `${q.name} ${q.result} (${q.record})`).join(', ')}`);
        load();
      } else {
        toast.error(res.data.message);
      }
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Failed to link game');
    } finally {
      setLinking(null);
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg" data-testid="qb-pickem-linker">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-xl font-bold text-[#001f3f] flex items-center gap-2"><Link2 className="h-5 w-5" /> Link Pick'em Results to QB Stats</h3>
        <select value={week} onChange={e => setWeek(parseInt(e.target.value))} className="border rounded px-3 py-2" data-testid="link-week-select">
          {Array.from({ length: Math.max(currentWeek || 1, 1) + 1 }, (_, i) => i).map(w => <option key={w} value={w}>QB Week {w}</option>)}
        </select>
      </div>
      <p className="text-sm text-slate-500 mb-4">Pick the QB week (handles bye weeks), then link a final game. Sets each SWAC QB's result and team record.</p>
      {games.length === 0 ? (
        <p className="text-slate-500" data-testid="link-games-empty">No final games yet. Mark games final in Pick'em Admin first.</p>
      ) : (
        <div className="space-y-2">
          {games.map(g => (
            <div key={g.id} className="border rounded-lg p-3 flex items-center justify-between gap-3" data-testid={`link-game-${g.id}`}>
              <div>
                <div className="font-medium">{g.away_team} {g.away_score} @ {g.home_team} {g.home_score}</div>
                <div className="text-xs text-slate-500">
                  {g.kickoff_time ? new Date(g.kickoff_time).toLocaleDateString() : ''}
                  {g.linked_week !== null && g.linked_week !== undefined && <span className="ml-2 text-green-600 font-semibold">Linked to Week {g.linked_week}</span>}
                </div>
              </div>
              <Button size="sm" onClick={() => link(g.id)} disabled={linking === g.id} data-testid={`link-game-btn-${g.id}`}>
                {linking === g.id ? 'Linking...' : `Link to Week ${week}`}
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
